import React, { useEffect, useState } from "react";
import { setToken } from "../../config/auth.js";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";

//import "./main.css";
//import "./util.css";
//import "./custom.css";
import "./login.scss";

import logoSeplag from "../../assets/img/logo-seplag.png";
import imgSistemaMonitora from "../../assets/img/SistemaMonitora.png";
import apoioSti from "../../assets/img/apoio-sti.png";
import ModalSeplag from "../../components/ModalSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";

import { classNames } from "../../config/global.js";

const Login = () => {
  const [exibirTelaSenha, setExibirTelaSenha] = useState(false);
  const [exibirTelaInfo, setExibirTelaInfo] = useState(false);
  const [exibirTelaInstrucao, setExibirTelaInstrucao] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isDisabledSubmit, setIsDisabledSubmit] = useState(true);
  const [matricula, setMatricula] = useState("");
  const [cpf, setCPF] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [mensagemConfirmacao, setMensagemConfirmacao] = useState("");
  const [colorMenssagemConfirmacao, setColorMenssagemConfirmacao] = useState("#07631e");
  const [exibirModalConfirmacaoSenha, setExibirModalConfirmacaoSenha] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  //  const toastBR = useRef(null);
  // const tokenRed = useSelector(state => state.tokenReducer)
  const urlLogin = window.location.origin + "/monitora";
  // this.codigoUrl = this.$route.query.codigo
  const query = new URLSearchParams(useLocation().search);

  useEffect(() => {
    if (query.get("codigo")) {
      var objValida = {
        codigoValidacao: query.get("codigo"),
        pathAplicacao: urlLogin,
        nomeSistema: process.env.REACT_APP_TITLE,
        assinaturaEmail: "SISTEMA MONITORA",
      };

      setExibirTelaInstrucao(false);

      window.$http.post(`/publicos/esquecisenha/novasenha`, JSON.stringify(objValida)).then((res) => {
        setMensagemConfirmacao(res.data.mensagem);
        setExibirModalConfirmacaoSenha(true);
      });
    } else {
      setExibirTelaInstrucao(true);
    }
  }, []);

  function fecharTelaInfo() {
    setExibirTelaInfo(false);
  }

  function fecharTelaSenha() {
    setExibirTelaSenha(false);
  }

  function fecharTelaInstrusao() {
    setExibirTelaInstrucao(false);
  }

  function AbreTelaInfo() {
    setExibirTelaInfo(true);
    setExibirTelaSenha(false);
  }

  function resetarSenha() {
    setExibirTelaInfo(false);
    setExibirTelaSenha(true);
  }

  function handleVerifyRecaptcha(event) {
    if (event.trim() !== "") {
      setIsDisabledSubmit(false);
    }
  }

  function alterarRegistro() {
    let dadosForm = {
      login: matricula,
      cpf,
      dataNascimento,
      pathAplicacao: urlLogin,
      nomeSistema: process.env.REACT_APP_TITLE,
      assinaturaEmail: "SISTEMA MONITORA",
    };

    window.$http
      .post(`/publicos/esquecisenha`, JSON.stringify(dadosForm))
      .then((res) => {
        setExibirTelaSenha(false);
        window.$toast.current.show({ severity: "success", summary: res.data.mensagem, life: 9000 });
      })
      .catch(() => {
        setExibirTelaSenha(false);
      });
  }

  function logar(e) {
    // dispatch({ type: "SETUSER", value: json });
    e.preventDefault();
    let formData = new FormData();
    formData.append("client", process.env.REACT_APP_USERNAME_API);
    formData.append("username", login);
    formData.append("password", password);
    formData.append("grant_type", "password");

    delete window.$http.defaults.headers.common["Content-Type"];
    window.$http.defaults.headers.common["Authorization"] = `Basic ${btoa(
      process.env.REACT_APP_USERNAME_API + ":" + process.env.REACT_APP_PASSWORD_API
    )}`;
    window.$http
      .post("/oauth/token", formData, {
        withCredentials: true,
        headers: { "Content-Type": "application/x-www-form-urlencoded; charset=ISO-8859-1" },
      })
      .then((res) => {
        let userlogado = {
          token: res.data,
          login: login,
          // password:password
        };
        setToken(JSON.stringify(userlogado));
        //Setando o Token na store do reducer
        // dispatch({type:'SETTOKEN',value: JSON.stringify(res.data)})

        window.$http.get(`/seguranca/contasacesso/me`).then((resUser) => {
          if (resUser.status == 200) {
            userlogado["user"] = resUser.data;
            dispatch({ type: "SETUSER", value: resUser.data });
            //Setando o userlogado na localStorage
            setToken(JSON.stringify(userlogado));
            history.push("/");
          }
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data) {
            if (error.response.data.error_description == "Bad credentials") {
              window.$toast.current.show({ severity: "error", summary: "Usuario ou Senha invalida!!", life: 3000 });
            } else {
              if (error.response.data.error == "unauthorized") {
                window.$toast.current.show({
                  severity: "error",
                  summary: error.response.data.error_description,
                  life: 3000,
                });
              } else {
                window.$toast.current.show({
                  severity: "error",
                  summary: "Ocorreu um erro na execução dessa operação",
                  life: 3000,
                });
              }
            }
          } else {
            window.$toast.current.show({
              severity: "error",
              summary: "Ocorreu um erro na execução dessa operação - codigo 502",
              life: 3000,
            });
          }
        } else {
          window.$toast.current.show({
            severity: "error",
            summary: "Ocorreu um erro na execução dessa operação - codigo 503",
            life: 3000,
          });
        }
        return false;
      });
  }

  return (
    <div className="container" style={{ userSelect: "none" }}>
      {/* <Toast ref={toastBR} position="bottom-right" /> */}
      <div className="div-login-sistema grid w-12 lg:w-9">
        <div className="md:col-6 ">
          <div className="grid main-container">
            <center className="center-header-login  my-2  md:mt-4 ">
              <img src={logoSeplag} alt="Secretaria de Estado de Planejamentoe Gestão" className="icon-login" />
              <p className="texto-sistema text-2xl sm:text-3xl lg:text-4xl">Sistema Monitora</p>
            </center>
            <div className="mx-auto" style={{ width: "80%" }}>
              <form>
                <div className="wrap-input100 validate-input mb-3" data-validate="Nome requerido">
                  <input
                    className="placeholder0 input100 border-none"
                    type="text"
                    id="login"
                    name="email"
                    value={login}
                    placeholder="Usuário"
                    onChange={(e) => setLogin(e.target.value)}
                  />
                  <span className="focus-input100"></span>
                </div>
                <div className="wrap-input100 validate-input mb-3" data-validate="Senha requerido">
                  <div className="input-eyes">
                    <input
                      className="placeholder0 input100 border-none"
                      type={showPassword ? "text" : "password"}
                      id="senha"
                      name="password"
                      value={password}
                      placeholder="Senha"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span className="focus-input100"></span>
                    <i
                      className={
                        "cursor-pointer input-button pi" +
                        classNames({ "pi-eye-slash": showPassword, "pi-eye": !showPassword })
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setShowPassword(!showPassword);
                      }}
                    />
                  </div>
                </div>
                <div
                  className="mb-3"
                  style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}
                >
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                    onChange={(event) => handleVerifyRecaptcha(event)}
                  />
                  <Button
                    disabled={isDisabledSubmit}
                    label="Entrar no sistema"
                    className="button-entrar-sistema"
                    onClick={logar}
                  />
                </div>
              </form>
              <div className="grid">
                <span
                  className="col-12 md:col-6 mb-0 text-center cursor-spanointer"
                  style={{ cursor: "pointer" }}
                  onClick={resetarSenha}
                >
                  Esqueci a minha senha
                </span>
                <span
                  style={{ cursor: "pointer" }}
                  className="col-12 md:col-6 text-center mb-0 cursor-pointer"
                  onClick={AbreTelaInfo}
                >
                  Informações de acesso
                </span>
              </div>
            </div>
            <div className="images-logos">
              <img src={apoioSti} className="sti-logo" alt="Superintendência de Tecnologia da Informação Setorial" />
            </div>
          </div>
        </div>
        <div className="hidden md:flex md:col-6 p-0 aside-container">
          <img src={imgSistemaMonitora} alt="Imagem Sistema Monitora" />
        </div>
      </div>

      <ModalSeplag
        titulo="Esqueci a minha senha"
        tamanho="800px"
        type={""}
        labelFechar="Fechar"
        labelAcao="Alterar"
        visible={exibirTelaSenha}
        fechar={fecharTelaSenha}
        funcAcao={alterarRegistro}
      >
        <div role="alert" className="p-messages p-component p-messages-warn p-md-6 p-col-12">
          <div className="alinhar-centro font-size-14 p-messages-wrapper">
            <p>
              (1) A sua senha inicial será encaminhada por e-mail após clicar na opção "Enviar link de ativação". Após o
              acesso ao portal com a senha provisória, será solicitada a alteração de senha.
            </p>
            <p>
              (2) Caso não consiga acessar o Portal, tente redefinir sua senha clicando no "Enviar link de ativação".
            </p>
            <p>
              (3) Caso seja verificado que o e-mail exibido não lhe está mais acessível, entre em contato com seu Órgão
              para atualização do e-mail no SEAP.
            </p>
          </div>
        </div>
        <br />
        <div className=" p-md-6 p-col-12">
          <RotuloSeplag nome="Matrícula ou Login">
            <InputText
              className="p-inputtext-lg p-d-block"
              type="text"
              value={matricula}
              onChange={(e) => setMatricula(e.target.value)}
            />
          </RotuloSeplag>
          <RotuloSeplag nome="CPF">
            <InputMask
              className="p-inputtext-lg p-d-block"
              mask="999.999.999-99"
              placeholder="999.999.999-99"
              value={cpf}
              onChange={(e) => setCPF(e.target.value)}
            />
          </RotuloSeplag>
          <RotuloSeplag nome="Data Nascimento">
            <InputMask
              className="p-inputtext-lg p-d-block"
              mask="99/99/9999"
              placeholder="dd/mm/aaaa"
              value={dataNascimento}
              onChange={(e) => setDataNascimento(e.target.value)}
            />
          </RotuloSeplag>
        </div>
      </ModalSeplag>
      <ModalSeplag
        type={"NONE"}
        tamanho="34em"
        visible={exibirTelaInfo}
        labelFechar="Fechar"
        fechar={() => fecharTelaInfo()}
        titulo="Mais Informações"
      >
        <div className="card-item">
          <a href="#" target="_blank">
            <h3 style={{ display: "inline" }}>Normativas</h3>
            <i className="pi pi-external-link"></i>
          </a>
        </div>
        <br />
        <div className="card-item">
          <a href="#" target="_blank">
            <h3 style={{ display: "inline" }}>Perguntas Frequentes</h3>
            <i className="pi pi-external-link"></i>
          </a>
        </div>
        <br />
        <div className="card-item">
          <a href="#" target="_blank">
            <h3 style={{ display: "inline" }}>Manuais e Autocapacitação</h3>
            <i className="pi pi-external-link"></i>
          </a>
        </div>
        <br />
        <div className="card-item">
          <a href="#" target="_blank">
            <h3 style={{ display: "inline" }}>Lista de Treinamento</h3>
            <i className="pi pi-external-link"></i>
          </a>
        </div>
      </ModalSeplag>
      <ModalSeplag
        type={"SIMPLES"}
        tamanho="34em"
        visible={exibirModalConfirmacaoSenha}
        labelFechar="Fechar"
        fechar={() => setExibirModalConfirmacaoSenha(false)}
      >
        <div className="confirmation-content" style={{ color: colorMenssagemConfirmacao }}>
          {colorMenssagemConfirmacao != "#07631e" ? (
            <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: "2em" }} />
          ) : (
            ""
          )}
          <span style={{ textAlign: "justify" }}>{mensagemConfirmacao}</span>
        </div>
      </ModalSeplag>
    </div>
  );
};

export default Login;
